import { InsightsDataState } from '@pages/cooper-insights/store/states/insights.state';
import { InsightFilterState } from '@pages/cooper-insights/store/states/insight-filter.state';
import { InsightModulesScoreDataState } from '@pages/cooper-insights/store/states/insights-module-score.state';

export const cooperInsightsState = [InsightsDataState, InsightFilterState, InsightModulesScoreDataState];
